import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

export default function CustomerExportLauncher({customerId}){
  const navigate=useNavigate();
  useEffect(()=>{
    const click=event=>{
      const button=event.target?.closest?.('.customer-action-bar button,.record-actions.customer-action-bar button');
      if(!button)return;
      const text=String(button.textContent||'').trim().replace(/\s+/g,' ').toLowerCase();
      if(text!=='export'&&text!=='export customer data')return;
      event.preventDefault();event.stopPropagation();event.stopImmediatePropagation?.();
      navigate(`/customers/${encodeURIComponent(customerId)}/export`);
    };
    document.addEventListener('click',click,true);
    return()=>document.removeEventListener('click',click,true);
  },[customerId,navigate]);
  return null;
}
